<ion-app class="theme-{{ environment.theme }}">
    <ion-router-outlet id="app-content"></ion-router-outlet>
    <ion-toast></ion-toast>
    <ion-alert></ion-alert>
    <ion-modal
        [isOpen]="showNonProductionWarning"
        [backdropDismiss]="false"
        class="environment-warning-modal adjusted"
    >
        <ng-template>
            <div class="environment-warning-modal__content ion-padding">
                <div class="environment-warning-modal__card">
                    <ion-badge color="warning">{{ nonProductionEnvironmentLabel }}</ion-badge>
                    <h2>Environnement non productif</h2>
                    <p>
                        Cette version n&apos;est pas la production. Verifie l&apos;URL et les donnees avant de continuer.
                    </p>
                    <div class="environment-warning-modal__details">
                        <p><strong>Site :</strong> {{ environment.websiteUrl }}</p>
                        <p><strong>API :</strong> {{ environment.apiUrl }}</p>
                    </div>
                    <ion-button expand="block" shape="round" (click)="closeNonProductionWarning()">
                        J&apos;ai compris
                    </ion-button>
                </div>
            </div>
        </ng-template>
    </ion-modal>
</ion-app>
